import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { CalendarComponent } from './calendar.component';
import { WeekViewCalendarComponentModule } from './week-view-calendar/week-view-calendar.module';
import { AllStylistViewCalendarComponentModule } from './all-stylist-view-calendar/all-stylist-view-calendar.module';
import { DayViewCalendarComponentModule } from './day-view-calendar/day-view-calendar.module';
import { TimeSlotComponentModule } from './time-slot/time-slot.module';
import { SalonMonsterLoadMaskModule } from '../../components/smr-load-mask/smr-load-mask.module';
import { SalonMonsterTapRetryModule } from '../../components/smr-tap-retry/smr-tap-retry.module';
import { SharedModule } from '../../shared.module';
import { StylistPickerModule } from '../../components/stylist-picker/stylist-picker.module';
import { DateRangeSelectorComponentModule } from '../../components/smr-date-picker/date-range-selector/date-range-selector.module';
import { CalendarDatePickerComponentModule } from './calendar-date-picker/calendar-date-picker.module'
import { MenuButtonComponentModule } from '../../components/smr-menu-button/smr-menu-button.module';
import { CalendarSettingsComponentModule } from './calendar-settings/calendar-settings.module';
import { SubscriptionBannerComponentModule } from 'src/app/components/subscription-banner/subscription-banner.module';
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    SalonMonsterLoadMaskModule,
    SalonMonsterTapRetryModule,
    SharedModule,
    WeekViewCalendarComponentModule,
    AllStylistViewCalendarComponentModule,
    DayViewCalendarComponentModule,
    TimeSlotComponentModule,
    StylistPickerModule,
    DateRangeSelectorComponentModule,
    CalendarDatePickerComponentModule,
    MenuButtonComponentModule,
    CalendarSettingsComponentModule,
    SubscriptionBannerComponentModule
  ],
  declarations: [
    CalendarComponent,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  exports: [CalendarComponent],
})
export class CalendarComponentModule {}
